import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CompetitorRegularAi from './competitor-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CompetitorRegularAi {...validProps} />;
}
SvgComponent.iconName = 'competitorRegularAi';

export const CompetitorRegularAiIcon = svgIconWrapper(SvgComponent);
